/* eslint-disable no-restricted-syntax */
/* eslint-disable react/jsx-one-expression-per-line */
import TableView from '@nile/banyan/src/Pages/ServiceCatalog/TableView';
import LoadingSuccess from '@nile/components/src/Svg/AnimatedSvg/LoadingSuccess.svg';
import { useCopyToClipboard } from '@nile/mangifera/src/Pages/MigrateDataPage/useCopyToClipboard';
import {
  B1,
  ContentDeciderContainer,
  getTranslatedText,
  Loader,
  TableLoading,
  BackgroundIcon,
  AppContext,
  getDownloadURL,
  ALL_MODULES,
  HourGlassLoader,
  TableContainer,
  Tag,
  B3T2,
  toast,
  ConfirmationModal,
  CustomConfirmationModal,
  DeleteModal,
  INVOICE_STATUS,
  getParsedCrudData,
  ListInfoBanner,
  BrandingLogo,
  TEXT_LENGTH,
  isAuthorised,
  formatDataForSelectDropdown,
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator,
  SkeletonTableLoading,
  CustomModal,
  Invoice,
  useIsAuthorisedHook,
  DateTimeFormatter,
  getHeaderValue,
  FeatureGuide,
  StateCountryLabel,
  TAX_ROUND_OFF,
  AccessControl,
  sideConversationPricingPlans,
  useUserMSPCheckHook,
  CurrencyText,
  DateTimePicker,
  AsyncPropSelector,
  calculateTermAndDueDate,
  useActivityTracker,
  useCheckFeatureGating,
  TAB_PAGES,
  Column,
  Row as RowLayout,
  SkeletonLoading,
  DisabledTag,
  useProduct,
  COMMON_CONSTANTS,
  CurrencyField
} from '@nile/components';
import PaidStamp from '@nile/components/src/Svg/AnimatedSvg/PaidStamp.svg';
import { EmailEditor } from '@nile/banyan/src/Components/Editors';
import ActiveIntegrationIcon from '@nile/client_management/src/Components/ActiveInvoiceBillingIntegrationIcon';
import { getTabId } from '@nile/mangifera/src/Pebbles/TabManager';
import InvoiceActionButtons from '@nile/client_management/src/Pages/Protected/ClientNavigation/InvoiceActionCell';
import {
  Button,
  Popover,
  TextField,
  Dropdown,
  Sheet,
  Banner,
  Heading,
  Page,
  Link,
  TextStyle,
  ButtonGroup,
  UnstyledLink,
  TextField as PolarisTextField,
  Card,
  DisplayText,
  Tippy
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import {
  AccountClient,
  GET_CLIENT_INVOICE,
  UPDATE_INVOICE,
  DELETE_INVOICE,
  GET_INTEGRATIONS_BY_IDS,
  GET_SEND_AND_INTEGRATION_STATUS,
  PUSH_INVOICE,
  SEND_INVOICES,
  GET_ALL_TAX,
  useLazyQuery as customUseLazyQuery,
  GET_INVOICE_PAYMENT_METHODS,
  CREATE_INVOICE_WITH_CONVERSATION,
  GENERATE_PAYMENT_LINK_TOKEN,
  GET_INVOICE_CONFIG,
  GET_ENTITY_PROPERTIES,
  FETCH_INVOICE_CONFIGURATION,
  MockTicketClient
} from '@nile/graphql';
import envConfig from '@nile/home/src/Config/env';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import TicketContext from '@nile/mangifera/src/Contexts/TicketContext';
import InvoiceTableContext from '@nile/client_management/src/Contexts/InvoiceTableContext';
import Loading from '@nile/components/src/Svg/AnimatedSvg/Loading.svg';
import { PSA_CONSTANTS } from '@nile/components/src/Constants/PSA';

import {
  isEmpty,
  includes,
  isEqual,
  omit,
  cloneDeep,
  debounce,
  clone,
  clamp
} from 'lodash';
import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
  useReducer
} from 'react';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { useMutation, useQuery, useLazyQuery } from '@apollo/client';
import { HIDE_PAYMENT_BUTTON_FOR_STATUS } from '@nile/client_management/src/Constants/invoice';
import InvoiceErrors from '@nile/client_management/src/Components/InvoiceErrors';
import { getTotalValue } from '@nile/banyan/src/Pebbles/tax';
import { DataGetter } from '@nile/components/src/Containers/Worklog/utils';
import { defaultLayoutConfigObj } from '@nile/banyan/src/Constants/defaultLayoutConfig';
import TermSelectDropdown from '@nile/client_management/src/Components/TermSelectDropdown';
import { SizeMe } from 'react-sizeme';
import dayjs from 'dayjs';
import DOMPurify from 'dompurify';
import InvoiceStatusCell from '@nile/client_management/src/Pages/Protected/ClientNavigation/InvoiceStatusCell';
import { InvoiceTableView } from '@nile/client_management/src/Pages/Invoice/InvoiceTableView';
import {
  dompurifier,
  downloadHack,
  EventEmitter,
  getEntityAttributes,
  roundToFixed,
  sanitizeWhiteSpace,
  EventDispatcher
} from '@nile/components/src/Utils/helpers';
import { DISCOUNT_TYPE } from '@nile/client_management/src/Pages/Invoice/constants';
import AdditionalPropertiesHolder from '@nile/client_management/src/Components/AdditionalProperties.tsx';
import FixedPositionActionsGroup from '@nile/client_management/src/Components/FixedPositionActionsGroup.tsx';
import InvoicePayment from './InvoicePayment';
import InvoiceConversations from './InvoiceConversations';
import ItemsToInvoice from './ItemsToInvoice';
import SendEmailModal from './SendEmailModal';
import { findItemOrderDiff, reorderItems, sortItems } from './Utils';
import {
  updateProperties as updatePropertiesHelper,
  calculateData,
  configureTableColumns,
  getSubTotal,
  getTaxes,
  generateInvoiceOrQuoteSummaryRows,
  checkRowHighlightHelper,
  usePdfDownloader,
  onRowItemDragEnd,
  hasCredits,
  useCredits,
  Stamp,
  SanitizedAddress,
  InvoiceCustomFields,
  ActiveIntegrationId,
  useInvoiceTypography,
  WHITE_TEXT_COLOR,
  DARK_TEXT_COLOR,
  accentDecider
} from '@nile/client_management/src/Utils/invoiceAndQuoteHelper';
import { useSitewiseSplit } from '@nile/client_management/src/Utils/useSitewiseSplit';
import { RecordPaymentModal } from '@nile/client_management/src/Pages/Invoice/RecordPayment';
import { PaymentSummaryButton } from '@nile/client_management/src/Pages/Invoice/PaymentSummaryModal';
import { GET_FIELDS } from '@nile/banyan/src/Graphql/Mutations/ticket';
import { getInvoiceUpdates } from '@nile/client_management/src/Utils/Hooks';
import { useGroupByCategory } from '@nile/client_management/src/Utils/useGroupByCategory';
import { InvoiceUsageReportPreviewButton } from './InvoiceUsageReport';
import { GET_PROJECTS } from '@nile/projects/src/Graphql';

const CopyButtonContainer = styled.div`
  margin-left: ${(props) => (props.rightAlign ? 'auto' : null)};
  svg {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }

  & .Superops-Button__Text {
    display: contents;
  }
  color: ${(props) => props.color};
`;

const ChatWrapper = styled.div`
  min-width: 550px;
  height: 100%;
  max-width: 700px;
  width: 560px;
  overflow: auto;
  overflow-x: hidden;
  border: 1px solid var(--sops-trans-white-border);
  .Superops-Tabs__Wrapper {
    border-radius: 10px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    box-shadow: none !important;
  }
`;

const Wrapper = styled.div`
  background: var(--sops-asset-activity-header-bg) !important;

  .Polaris-Page-Header {
    padding: 20px !important;
  }
  &.large-screen {
    .Superops-Page {
      min-width: 1000px;
    }
  }
  .Superops-Page-Header {
    padding: 20px !important;
  }
  .Superops-Page__Content,
  .Superops-Page--contentPrimary {
    padding: 20px 0 !important;
  }
  .Superops-Heading .Superops-Heading--sizePrimary {
    font-size: 20px !important;
  }
  .Superops-TextField__ActionableSuffix {
    background: ${(props) =>
      props.clicked ? '#fffae4' : 'rgba(0, 0, 0, 0.05)'};
    border-radius: 10px 10px 0 0;
    transition: background 200ms linear;
  }
  .colHeader {
    padding-left: 8px;
  }
  .Superops-TextField__Input {
    border-bottom: 1px solid #ececec;
  }
  .Superops-Connected {
    padding-top: 0 !important;
  }
  .Superops-TextField__Input {
    min-height: 38px;
  }
  .Superops-TextField__Input {
    padding-left: 4px;
  }
  .Superops-Banner__Position {
    width: 100%;
  }
  .red {
    color: red;
  }
  .sk-table-container {
    height: 400px !important;
  }
  .branding-logo {
    margin-bottom: 10px !important;
  }
  .msp-name {
    font-size: 18px !important;
    // margin-left: 10px;
    font-weight: 600;
  }
`;

const ClientInfo = styled.div`
  margin-bottom: 10px;
  .site-info {
    line-height: 21px;
  }

  [data-id='entityAttribute.client.name'],
  [data-id='attribute.msp.name'],
  [data-id='entityAttribute.site.name'] {
    font-size: 20px;
    font-weight: 600;
  }
`;

const DateSection = styled.div`
  .react-datepicker-wrapper,
  .react-datepicker__input-container > input {
    width: 170px;
  }
`;

const Row = styled.div`
  line-height: 35px;
  font-weight: 500;
  width: ${(props) => props.width};
`;

const Notes = styled.div`
  textarea {
    height: 270px !important;
  }
`;

const ExportCSVWrapper = styled.div`
  .Superops-Button {
    padding: 0 !important;
  }
  .Superops-Button__Text {
    padding: 0;
  }
  .actionListItemPadding {
    padding: 0.8rem 1.6rem;
  }
  .actionListItemPadding:hover {
    background-color: transparent !important;
  }
`;

const PageHeader = styled.div`
  padding: ${(props) => (props.restrictActions ? '' : '10px')};
  border-bottom: 1px solid var(--sops-trans-white-border);
  .module-logo {
    height: 45px !important;
    width: 45px !important;
  }
  .invoice-page-heading {
    font-size: 24px !important;
  }
`;
const ContentWrap = styled.div`
  height: ${(props) => (props?.restrictActions ? '100%' : 'calc(100% - 97px)')};
  .content-padding {
    padding: 0 20px !important;
  }
`;

const MemoGetter = styled(DataGetter)`
  background: transparent;
  border: 1px solid #ececec;
  border-radius: 10px;
  .Superops-Connected,
  .Superops-TextField {
    height: 100%;
  }
  textarea {
    height: 100% !important;
    font-weight: normal !important;
  }
`;

const DisplayMemo = styled(DataGetter)`
  border: 1px solid #ececec;
  background: none;
  border-radius: 10px;
  border: none !important;
  padding: 0px 15px;
  min-height: 38px;
  display: flex;
  flex-grow: 1;
  textarea {
    font-weight: normal !important;
  }
  .Superops-TextField__Input:disabled,
  .Superops-TextField--variantOutline > input:disabled,
  .Superops-TextField--variantOutline {
    background-color: transparent !important;
    cursor: auto !important;
  }
`;

const EditorHolder = styled.div`
  // height: 400px;
  // padding: 20px;
  margin: 20px;
  border: 1px solid #ececec;
  border-radius: 10px;
  #quill-rt-editor {
    height: 100%;
    .quill {
      min-height: 200px;
      .ql-container {
        border: none;
        min-height: inherit;
        .ql-editor {
          min-height: inherit;
        }
      }
    }
    .ql-toolbar {
      border: none;
    }
  }
`;

const TextFieldStyleWrapper = styled.div`
  .Superops-TextField__ActionablePrefix,
  .Superops-TextField__ActionableSuffix {
    border: none !important;
    padding-left: 0 !important;
  }
  .Polaris-TextField__Backdrop {
    border: none !important;

    &::after {
      border: none !important;
    }
  }
  .Polaris-TextField__Input {
    border-bottom: 1px solid rgba(151, 151, 151, 0.3);

    &:focus {
      border-bottom: 1px solid #0a0b10;
    }
  }
`;

export const FlexColumnGap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.gap ?? 20}px;
`;

const invoiceNode = React.createRef();

// const invoiceWorker = new Worker('./Workers/invoiceEditCalculations.js');

const dataQueue = [];
const currentProcessRunning = false;
let invoicePdfLoaderTimeout;

export const InvoiceThemeWrapper = styled.div`
  ${(props) => {
    if (props.fontFamily) {
      return ` * {
    font-family: ${props.fontFamily || 'inherit'} !important;
  }`;
    }
    return '';
  }}

  .colHeader,
  .columHeader,
  .total-card,
  .total-card-partiallyPaid-section {
    background-color: ${(props) => props.accentBgColor};
    color: ${(props) => props.accentTextColor};
  }

  .Superops-Page-Header__PrimaryActionWrapper {
    height: 100%;
  }

  ${(props) => {
    if (!props.isAccentEnabled) {
      return `
      .total-card{
      border-bottom: 2px solid rgba(0, 0, 0, 0.40);
      }

      .columHeader{
      border-top: unset;

      th{
      border-bottom: 2px solid rgba(0, 0, 0, 0.40);
      .colHeader{
      border-right: 1px solid rgba(0, 0, 0, 0.80);
      }
      }
      }
      `;
    }
  }}

  ${(props) => {
    if (props.theme === PSA_CONSTANTS.INVOICE_TEMPLATE_THEME.ELEGANT) {
      return `.custom-fields-wrapper {
    background-color: ${props.accentBgColor};
      color: ${props.accentTextColor};

      .react-datepicker__input-container input{
      color: ${props.accentTextColor};
      }

      .Superops-TextField{
        background: transparent;
        input.Superops-TextField__Input{
          background: transparent;
          color: ${props.accentTextColor};
        }
      }

      .value_selector__control ,.value_selector__single-value{
        background-color: ${props.accentBgColor};
        color: ${props.accentTextColor};
      }
  }`;
    }
    return '';
  }}
`;

function InvoiceDetails(props) {
  const { intl, match, isOpenedViaNonLogin, isClassicView } = props;
  const hasUsagereportRef = useRef(false);
  const isConversationViewAuthorised = useIsAuthorisedHook(
    'clientConversation.view'
  );
  const isInvoiceCustomFieldsAuthorised = useIsAuthorisedHook(
    'billingCustomFields.view'
  );
  const isClientCustomFieldsAuthorised = useIsAuthorisedHook(
    'clientCustomFields.view'
  );
  const appContext = useContext(AppContext);
  const params = new URLSearchParams(props.location.search);
  const isSendInvoice = params.get('send');
  const { user } = appContext;
  const isItProduct = useProduct(COMMON_CONSTANTS.IT);

  const contractsNew = useCheckFeatureGating('CONTRACT_V3')?.enabled;

  const { INVOICE_TEMPLATE_THEME } = PSA_CONSTANTS;

  const isInvoiceSettingsViewAuthorised =
    props.restrictActions || useIsAuthorisedHook('invoiceSettings.view');
  const reference = user?.role?.roleFeatureList || [];
  const isInvoiceEditAuthorised = isAuthorised(reference, 'invoice.edit');
  const isInvoiceDeleteAuthorised = isAuthorised(reference, 'invoice.delete');
  const company = props.company || appContext.company;
  const { companyInfo } = appContext;
  const [customModal, setCustomModal] = useState(false);

  const [generateLinkLoading, setGenerateLinkLoading] = useState(false);
  const [invoiceSettings, setInvoiceSettings] = useState(null);
  const [inactiveFields, setInactiveFields] = useState([]);
  const isMsp = useUserMSPCheckHook();
  const currencyCode = companyInfo?.currency || company?.currency || 'USD';
  const countryCode = company?.countryCode || 'US';
  const { id } = match.params;
  const invoiceId =
    props.invoiceId || (match?.params?.viewtype === 'invoiceList' ? id : null);
  const {
    invoiceData: invoiceDataFromWebSocket,
    sendClientEvent
  } = getInvoiceUpdates(invoiceId);
  const accountClient = props.accountClient || AccountClient;
  const [isStripeIntegrated, setIsStripeIntegrated] = useState(false);
  const [currentPaymentIntegration, setCurrentPaymentIntegration] = useState(
    null
  );
  const ticketContext = useContext(TicketContext);
  const invoiceContext = useContext(InvoiceTableContext);

  const [columnGroup, setColumnGroup] = useState([
    { Header: 'Name', columns: [] }
  ]);
  const [activeSheetName, setActiveSheetName] = useState('Conversation');
  const [sheetActive, setSheetActive] = useState(false);
  const toggleSheetActive = useCallback((sheetName) => {
    setActiveSheetName(sheetName || null);
    setSheetActive(!sheetActive);
  });
  const [data, setData] = useState({});
  const [termDueDate, setTermDueDate] = useState(null);
  const [manipulatedData, setManipulatedData] = useState({});
  const dataRef = useRef(0);
  dataRef.current = data;
  const [listLoading, setListLoading] = useState(true);
  const [
    invoiceGenerationInProgress,
    setInvoiceGenerationInProgress
  ] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [paymentState, setPaymentState] = useState('list');
  const [listInfo, setListInfo] = useState({});
  const [active, setActive] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const editModeRef = React.useRef(2);
  editModeRef.current = editMode;
  const [actionLoading, setActionLoading] = useState(false);
  const [invoiceNote, setInvoiceNote] = useState('');
  const [integrationAppAndInvoiceId, setIntegrationAppAndInvoiceId] = useState(
    null
  );
  const [paymentDate, setPaymentDate] = useState(
    dayjs(new Date()).format('YYYY-MM-DD')
  );
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [paymentReference, setpPaymentReference] = useState('');

  const [invoicePaidErrors, setInvoicePaidErrors] = useState({});
  const [showSendEmailModal, setShowSendEmailModal] = useState(false);
  const isEditInvoiceAuthorised = useIsAuthorisedHook('invoice.edit');
  const closeModal = useCallback(() => {
    setCustomModal(false);
  });
  const [allTaxData, setAllTaxData] = useState(null);

  const [applyCreditsLoading, setApplyCreditsLoading] = useState(false);

  const {
    availableCredits,
    hasCredits: hasClientCredits,
    refetchCredits
  } = useCredits(data?.client?.accountId, props.restrictActions);

  const {
    loading: entitiesLoading,
    error: entitiesError,
    data: allEntities
  } = useQuery(GET_ENTITY_PROPERTIES, {
    client: accountClient
  });

  const [getAllTax, { loading: taxLoading, data: taxData }] = useLazyQuery(
    GET_ALL_TAX,
    {
      client: AccountClient,
      onCompleted(response) {
        setAllTaxData(response?.getAllTax);
      }
    }
  );

  const taxRateList = taxData
    ? formatDataForSelectDropdown(taxData?.getAllTax)
    : [];

  const toggleActive = useCallback(() => setActive((active) => !active), []);

  const { isSiteWiseSplitEnabled, dataGroupedBySite } = useSitewiseSplit({
    data,
    invoiceSettings
  });

  const {
    isGroupByCategoryEnabled,
    dataGroupedByCategory
  } = useGroupByCategory({
    data,
    invoiceSettings
  });

  const isInvoiceAddAuthorised = useIsAuthorisedHook('invoice.add');

  const isAdditionalDiscountPercent =
    data?.additionalDiscountType === DISCOUNT_TYPE.PERCENT;

  const tableConfig = {
    ...defaultLayoutConfigObj.tableConfig,
    ...invoiceSettings?.invoiceTemplate?.layoutConfiguration?.tableConfig
  };

  const styleCustomization =
    invoiceSettings?.invoiceTemplate?.layoutConfiguration?.styleCustomization ||
    defaultLayoutConfigObj.styleCustomization;

  const {
    accent,
    typography,
    theme: invoiceTemplateTheme
  } = styleCustomization;

  const {
    fontLoaded,
    fontStyles,
    className: typographyClassName
  } = useInvoiceTypography(typography);

  const {
    pdfDownloadLoading,
    onPdfDownloadClick,
    setPdfDownloadLoading: setPDFDownloadLoading
  } = usePdfDownloader({
    downloadDetails: () => {
      const baseURL = localStorage?.getItem('apiDomain') + envConfig.fileRoot;
      const downloadDetails = new URL(`${baseURL}/download_invoice`);
      downloadDetails.search = new URLSearchParams({
        details: JSON.stringify({
          invoiceId: invoiceId,
          clientId: data.client.accountId
        })
      });
      return downloadDetails;
    },
    filePrefix: 'invoice',
    id: invoiceId
  });

  const integrationKeyMap = {
    FLEXPOINT: 'Flex Point',
    ALTERNATIVE_PAYMENTS: 'Alternative Payments'
  };

  const alternatePayments = ['ALTERNATIVE_PAYMENTS', 'FLEXPOINT'];

  const integrations = [
    'STRIPE',
    'QUICK_BOOKS_ONLINE',
    'XERO',
    'QUICK_BOOKS_DESKTOP',
    'ALTERNATIVE_PAYMENTS',
    'FLEXPOINT'
  ];

  const isTicketAuth = useIsAuthorisedHook('tickets.view');
  const isProjectAuth = useIsAuthorisedHook('project.view');
  const isQuoteAuth = useIsAuthorisedHook('quote.view');

  const [
    getProjects,
    { loading: projectsLoading, data: projectsData }
  ] = useLazyQuery(GET_PROJECTS);

  const {
    isTicketViewAuthorised,
    isQuoteViewAuthorised,
    isProjectViewAuthorised
  } = useMemo(() => {
    const module = data?.work?.module || null;
    const hasProjectId = !!data?.work?.project?.projectId;
    const hasProjects = projectsData?.getProjects?.projects?.length > 0;

    return {
      isTicketViewAuthorised: module === 'TICKET' ? isTicketAuth : false,
      isQuoteViewAuthorised: data?.quote?.quoteId ? isQuoteAuth : false,
      isProjectViewAuthorised:
        hasProjectId && isProjectAuth ? hasProjects : false
    };
  }, [
    data?.work?.module,
    data?.quote?.quoteId,
    data?.work?.project?.projectId,
    isTicketAuth,
    isQuoteAuth,
    isProjectAuth,
    projectsData
  ]);

  useEffect(() => {
    if (isMsp && isProjectAuth && data?.work?.project?.projectId) {
      getProjects({
        variables: {
          listInfo: {
            condition: {
              joinOperator: 'AND',
              operands: [
                {
                  attribute: 'projectId',
                  operator: 'is',
                  value: data?.work?.project?.projectId
                }
              ]
            }
          },
          isItProduct: isItProduct
        }
      });
    }
  }, [data?.work?.project?.projectId, isProjectAuth]);

  const {
    loading: integrationsLoading,
    data: integrationsData,
    error: integrationsError
  } = useQuery(GET_INTEGRATIONS_BY_IDS, {
    variables: {
      integrationIds: integrations
    },
    client: accountClient,
    onCompleted({ getIntegrationsByIds }) {
      if (getIntegrationsByIds) {
        if (
          getIntegrationsByIds.find(
            (integration) => integration.integrationId === 'STRIPE'
          )?.activated
        ) {
          setIsStripeIntegrated(true);
        }

        const activatedPaymentIntegration = getIntegrationsByIds.find(
          (integration) => alternatePayments.includes(integration.integrationId)
        );

        if (activatedPaymentIntegration?.activated) {
          setCurrentPaymentIntegration(activatedPaymentIntegration);
        }
      }
    }
  });

  function handleTermChange(newPaymentTerm) {
    let dueDate = null;
    let paymentTerm = {};

    if (newPaymentTerm !== null) {
      dueDate = calculateTermAndDueDate(
        data.invoiceDate,
        newPaymentTerm.placeholder,
        newPaymentTerm?.paymentTermValue
      );
      paymentTerm = newPaymentTerm;
    }

    setTermDueDate(dueDate);

    updateProperties({
      properties: {
        dueDate: dueDate,
        invoicePaymentTerm: paymentTerm
      }
    });
  }

  const [
    getClientInvoiceSettings,
    { loading: clientInvoiceSettingsLoading }
  ] = customUseLazyQuery(FETCH_INVOICE_CONFIGURATION, {
    client: accountClient,
    fetchPolicy: 'cache-and-network',
    onCompleted(response) {
      setInvoiceSettings({
        ...response?.fetchInvoiceConfiguration,
        invoiceTemplate: {
          ...response?.fetchInvoiceConfiguration?.invoiceTemplate,
          layoutConfiguration: {
            ...defaultLayoutConfigObj,
            ...response?.fetchInvoiceConfiguration?.invoiceTemplate
              ?.layoutConfiguration
          }
        }
      });

      if (response?.fetchInvoiceConfiguration?.invoicePaymentMethod) {
        setPaymentMethod({
          ...response?.fetchInvoiceConfiguration?.invoicePaymentMethod,
          label:
            response?.fetchInvoiceConfiguration?.invoicePaymentMethod
              ?.paymentMethodName,
          value:
            response?.fetchInvoiceConfiguration?.invoicePaymentMethod
              ?.paymentMethodId
        });
      }
    }
  });

  // Invoice send and push to integrated app actions
  const [pushToThirdParty] = useMutation(PUSH_INVOICE, {
    client: AccountClient
  });

  const [sendInvoice] = useMutation(SEND_INVOICES, {
    client: AccountClient
  });

  const [updateSendIntegrationStatus] = useLazyQuery(
    GET_SEND_AND_INTEGRATION_STATUS,
    {
      client: AccountClient,
      onCompleted: ({ getInvoice }) => {
        if (getInvoice) {
          setData({ ...data, ...getInvoice });
        }
      },
      fetchPolicy: 'network-only'
    }
  );

  const [invoiceConfigLoading, setInvoiceConfigLoading] = useState(false);

  useEffect(() => {
    if (isMsp || isOpenedViaNonLogin) return;
    const accountId = data?.client?.accountId;
    if (!accountId) return;

    (async () => {
      try {
        setInvoiceConfigLoading(true);
        const resp = await AccountClient.query({
          query: GET_INVOICE_CONFIG,
          variables: { input: { accountId } },
          fetchPolicy: 'network-only'
        });
        const cfg = resp?.data?.getInvoiceConfiguration;
        setInvoiceSettings((curr) => ({
          ...curr,
          invoiceTemplate: {
            layoutConfiguration: {
              ...defaultLayoutConfigObj,
              ...cfg?.layoutConfiguration
            },
            preferences: cfg?.preferences
          }
        }));
      } catch (_) {
        // no-op
      } finally {
        setInvoiceConfigLoading(false);
      }
    })();
  }, [data?.client?.accountId, isMsp, isOpenedViaNonLogin]);

  const thirdPartyInvoiceApp =
    integrationsData?.getIntegrationsByIds?.length > 0 &&
    integrationsData?.getIntegrationsByIds?.find(
      (el) =>
        (el.integrationId === 'QUICK_BOOKS_ONLINE' ||
          el.integrationId === 'QUICK_BOOKS_DESKTOP' ||
          el.integrationId === 'XERO') &&
        el.activated
    );

  const isXeroIntegrated = !!integrationsData?.getIntegrationsByIds?.find(
    (el) => el.integrationId === 'XERO'
  );

  const updateTemplate = (obj) => {
    const modifiedData = cloneDeep(dataRef.current);
    modifiedData.template = {
      ...modifiedData.template,
      ...obj
    };
    setData(modifiedData);
  };

  const updateMemo = (val) => {
    const modifiedData = cloneDeep(dataRef.current);
    modifiedData.memo = val;
    setData(modifiedData);
  };

  const updateTitle = (val) => {
    const modifiedData = cloneDeep(dataRef.current);
    modifiedData.title = val;
    setData(modifiedData);
  };

  const thirdPartyAppId = thirdPartyInvoiceApp?.integrationId;

  const allowPushToThirdParty = !!thirdPartyInvoiceApp?.activated;

  const notClient = appContext.accountType !== 'CLIENT';

  const [updateInvoice] = useMutation(UPDATE_INVOICE, {
    client: AccountClient
  });

  const [deleteInvoice] = useMutation(DELETE_INVOICE, {
    client: AccountClient
  });

  const [generatePaymentLinkToken] = useMutation(GENERATE_PAYMENT_LINK_TOKEN, {
    client: AccountClient
  });

  const [
    sendInvoiceWithConversation,
    { loading: sendInvoiceWithConversationLoading }
  ] = useMutation(CREATE_INVOICE_WITH_CONVERSATION, {
    client: AccountClient
  });

  useEffect(() => {
    if (invoiceId) fetchViewData();
    if (sendClientEvent) {
      sendClientEvent('REGISTER_PAGE', invoiceId);
    }
    setEditMode(false);
    setPDFDownloadLoading(false);
  }, [invoiceId]);

  useEffect(() => {
    if (invoiceDataFromWebSocket?.pushedToIntegratedAppStatus) {
      const modifiedData = cloneDeep(dataRef.current);
      modifiedData.pushedToIntegratedAppStatus =
        invoiceDataFromWebSocket.pushedToIntegratedAppStatus;

      if (!isEmpty(invoiceDataFromWebSocket.integratedAppInvoiceId)) {
        modifiedData.integratedAppInvoiceId =
          invoiceDataFromWebSocket.integratedAppInvoiceId;
        setIntegrationAppAndInvoiceId(
          invoiceDataFromWebSocket.integratedAppInvoiceId?.split('#')
        );
      }

      if (invoiceDataFromWebSocket.pushedToIntegratedAppError) {
        modifiedData.pushedToIntegratedAppError =
          invoiceDataFromWebSocket.pushedToIntegratedAppError;
      }

      setData(modifiedData);
    }
  }, [invoiceDataFromWebSocket]);

  const handleRegeneration = () => {
    let newItems = data.items;

    if (isSiteWiseSplitEnabled) {
      newItems = Object.entries(dataGroupedBySite).reduce(
        (acc, [, { items }]) => {
          acc.push(
            ...sortItems(items).map((item, index) => {
              const startIndex = index + 1;
              return { ...item, itemOrder: startIndex + acc.length };
            })
          );

          return acc;
        },
        []
      );
    }

    if (isGroupByCategoryEnabled) {
      newItems = dataGroupedByCategory.reduce((acc, { items }) => {
        acc.push(
          ...sortItems(items).map((item, index) => {
            const startIndex = index + 1;
            return { ...item, itemOrder: startIndex + acc.length };
          })
        );
        return acc;
      }, []);
    }

    const parsedObject = getParsedCrudData(
      manipulatedData.items,
      newItems,
      'itemId'
    );

    let dragReorderedArray = [];
    let isDataModified;

    if (parsedObject.updatedItems.length) {
      const { result, dataModified } = findItemOrderDiff(
        manipulatedData.items,
        parsedObject.updatedItems
      );
      dragReorderedArray = result;
      isDataModified = dataModified;
    }

    const inputObject = {};
    const updatedLineItems = !isDataModified
      ? dragReorderedArray
      : parsedObject.updatedItems.map((el) => {
          return {
            itemId: el.itemId,
            itemOrder: el.itemOrder,
            details: el.details,
            [contractsNew ? 'serviceCatalogItem' : 'serviceItem']: {
              itemId: el?.serviceCatalogItem?.itemId
            },
            quantity: el.quantity,
            unitPrice: el.unitPrice,
            discountRate:
              el.discountRate === null
                ? el.discountRate
                : el.hasOwnProperty('discountRate')
                ? el.discountRate || '0'
                : null,
            discountAmount:
              el.discountAmount === null
                ? el.discountAmount
                : el.hasOwnProperty('discountAmount')
                ? el.discountAmount || '0'
                : null,
            taxable: el.taxable,
            tax: el?.tax?.taxId
              ? {
                  taxId: el?.tax?.taxId
                }
              : null,
            billedDate: dayjs(el?.billedDate).format('YYYY-MM-DD')
          };
        });
    const deletedLineItems = parsedObject.deletedItems.map((el) => {
      return {
        itemId: el.itemId
      };
    });
    const addedLineItems = parsedObject.addedItems.map((el) => {
      return {
        itemOrder: el.itemOrder,
        billedDate: el.billedDate || dayjs().format('YYYY-MM-DD'),
        details: el.details,
        offeredItem: el.offeredItem
          ? {
              itemId: el.offeredItem.itemId
            }
          : undefined,
        [contractsNew ? 'serviceCatalogItem' : 'serviceItem']: {
          itemId: el?.serviceCatalogItem?.itemId
        },
        quantity: el.quantity || '0',
        unitPrice: el.unitPrice || '0',
        discountRate:
          el.discountRate === null
            ? el.discountRate
            : el.hasOwnProperty('discountRate')
            ? el.discountRate || '0'
            : null,
        discountAmount:
          el.discountAmount === null
            ? el.discountAmount
            : el.hasOwnProperty('discountAmount')
            ? el.discountAmount || '0'
            : null,
        taxable: el.taxable,
        tax: el?.tax?.taxId
          ? {
              taxId: el?.tax?.taxId
            }
          : null
      };
    });
    if (
      manipulatedData.additionalDiscountRate !== data.additionalDiscountRate
    ) {
      inputObject.additionalDiscountRate =
        data.additionalDiscountRate === null
          ? data.additionalDiscountRate
          : data.additionalDiscountRate || '0';
    }
    if (manipulatedData.additionalDiscount !== data.additionalDiscount) {
      inputObject.additionalDiscount =
        data.additionalDiscount === null
          ? data.additionalDiscount
          : data.additionalDiscount || '0';
    }
    if (parsedObject.updatedItems.length) {
      inputObject.updateItems = updatedLineItems;
    }
    if (parsedObject.deletedItems.length) {
      inputObject.deleteItems = deletedLineItems;
    }
    if (parsedObject.addedItems.length) {
      inputObject.addItems = addedLineItems;
    }
    if (manipulatedData.invoiceDate !== data.invoiceDate) {
      inputObject.invoiceDate = data.invoiceDate;
    }
    if (data?.invoicePaymentTerm?.paymentTermId) {
      inputObject.paymentTerm = {
        paymentTermId: data.invoicePaymentTerm.paymentTermId
      };
    }
    if (manipulatedData.dueDate !== data.dueDate) {
      inputObject.dueDate = data.dueDate;
    }
    inputObject.title = data.title || undefined;
    inputObject.memo =
      manipulatedData.memo !== data.memo ? data.memo : undefined;
    inputObject.footer = data.template?.content || undefined;
    inputObject.inlineImages = data?.template?.inlineImages?.length
      ? data?.template?.inlineImages
      : undefined;
    inputObject.customFields = data?.customFields || undefined;
    setInvoiceGenerationInProgress(true);
    updateInvoice({
      variables: {
        updatedInvoice: {
          invoiceId,
          ...inputObject
        },
        isTaxSplitEnabled: true
      },
      input: {
        updatedInvoice: {
          invoiceId,
          ...inputObject
        }
      }
    })
      .then((res) => {
        setInvoiceGenerationInProgress(false);
        if (res?.data?.updateInvoice) {
          toast('success', 'invoice.regeneration.success');
          setData({
            ...res?.data?.updateInvoice,
            template: {
              content: res?.data?.updateInvoice?.footer || '',
              inlineImages: []
            },
            client: data.client
          });
          setManipulatedData({
            ...res?.data?.updateInvoice,
            template: {
              content: res?.data?.updateInvoice?.footer || '',
              inlineImages: []
            },
            client: data.client
          });
          setEditMode(false);
        }
      })
      .catch((err) => {
        setInvoiceGenerationInProgress(false);
      });
  };

  const updateProperties = (args) => {
    updatePropertiesHelper(args, dataRef, setData, invoiceSettings);
  };

  const calculateDataWithoutWorker = (arg) => {
    setData(
      calculateData(arg, {
        isSiteWiseSplitEnabled,
        isGroupByCategoryEnabled
      })
    );
  };

  const modifyData = (args) => {
    const {
      key,
      value,
      field,
      meta,
      properties,
      itemProperties,
      miscProperty,
      miscItem
    } = args;

    const modifiedData = cloneDeep(dataRef.current);

    calculateDataWithoutWorker({
      modifiedData,
      key,
      value,
      field,
      meta,
      properties,
      itemProperties,
      miscProperty,
      miscItem
    });
  };

  const setColumnData = () => {
    setColumnGroup(
      configureTableColumns({
        intl,
        tableConfig,
        data,
        onChange: modifyData,
        currencyCode,
        countryCode,
        editMode,
        editModeRef,
        includeWorklogDate: true,
        isQuote: false
      })
    );
  };

  useEffect(() => {
    setColumnData();
  }, [editMode]);

  useEffect(() => {
    setColumnData();
  }, [data, tableConfig.discountRate, tableConfig.tax]);

  const checkRowHighlight = (row) =>
    checkRowHighlightHelper(row, manipulatedData);

  /**
   * Method to get Service items.
   * Call this method to fetch/refetch the data on mounting/sorting/filtering
   */

  async function fetchViewData(ignoreSettingsFetch = false) {
    setListLoading(true);
    let clientCustomFields = {};

    await accountClient
      .query({
        query: GET_INVOICE_CONFIG
      })
      .then((res) => {
        if (res?.data?.getInvoiceConfiguration?.preferences?.fieldSettings) {
          clientCustomFields = res?.data?.getInvoiceConfiguration?.preferences?.fieldSettings?.filter(
            (field) => field?.entity === 'Client'
          );
          const customFieldsToGetDetails = res?.data?.getInvoiceConfiguration?.preferences?.fieldSettings
            ?.filter((field) => field?.fieldCategory === 'CUSTOM')
            ?.filter((field) => {
              if (field?.entity === 'Invoice') {
                return isInvoiceCustomFieldsAuthorised;
              }
              if (field?.entity === 'Client') {
                return isClientCustomFieldsAuthorised;
              }
              return false;
            });
          if (customFieldsToGetDetails?.length) {
            accountClient
              .query({
                query: GET_FIELDS,
                variables: {
                  input: customFieldsToGetDetails?.map((field) => ({
                    entity:
                      field?.entity === 'Invoice' ? 'Billing' : field?.entity,
                    columnName: field?.fieldName
                  }))
                },
                fetchPolicy: 'no-cache'
              })
              .then((res) => {
                setInactiveFields(
                  res?.data?.getFields
                    ?.filter((field) => field?.status === 'INACTIVE')
                    ?.map((field) => field?.columnName)
                );
              });
          }
        }
      });

    const response = await accountClient.query({
      query: GET_CLIENT_INVOICE,
      variables: {
        invoiceId: invoiceId,
        isIntegratedInvoiceId: true,
        isTaxSplitEnabled: true,
        clientCustomFields:
          clientCustomFields?.map((field) => field?.fieldName) || []
      },
      fetchPolicy: 'network-only'
    });
    if (response) {
      setColumnGroup(
        configureTableColumns({
          intl,
          tableConfig,
          data: response?.data?.getInvoice,
          onChange: modifyData,
          currencyCode,
          countryCode,
          editMode: false,
          includeWorklogDate: true,
          isQuote: false
        })
      );

      if (
        response?.data?.getInvoice?.client?.accountId &&
        invoiceId &&
        isInvoiceSettingsViewAuthorised &&
        !ignoreSettingsFetch
      ) {
        getClientInvoiceSettings({
          variables: {
            input: {
              accountId: response?.data?.getInvoice?.client?.accountId
            }
          }
        });
      }
      if (response?.data?.getInvoice) {
        setData({
          ...response?.data?.getInvoice,
          template: {
            content: response?.data?.getInvoice?.footer || '',
            inlineImages: []
          }
        });
      }
      setIntegrationAppAndInvoiceId(
        response?.data?.getInvoice?.integratedAppInvoiceId?.split('#')
      );
      setManipulatedData(response?.data?.getInvoice);
      setInvoiceNote(response?.data?.getInvoice?.notes || '');
      setListLoading(false);
      if (isSendInvoice) {
        setShowSendEmailModal(true);
      }
    }
  }

  useEffect(() => {
    if (invoiceId) fetchViewData();
  }, []);

  useEffect(() => {
    if (paymentState === 'list') {
      fetchViewData();
    }
  }, [paymentState]);

  useEffect(() => {
    return EventDispatcher.subscribe('refetchInvoice', () =>
      fetchViewData(true)
    );
  }, [invoiceId, isSendInvoice]);

  if (
    listLoading ||
    projectsLoading ||
    clientInvoiceSettingsLoading ||
    invoiceConfigLoading ||
    isEmpty(data) ||
    !fontLoaded
  ) {
    return (
      <>
        {isClassicView ? (
          <div className="pt16 sops-display-block">
            <SkeletonLoading
              hideStepNav
              showPlainCardView={false}
              showCardView={false}
              noThumbnail
            />
          </div>
        ) : (
          <div className="w100 fhp flex actr jctr">
            <div className="invoice-loader">
              <Loading />
            </div>
          </div>
        )}
      </>
    );
  }

  const { client, billTo } = data;
  const module = ALL_MODULES.invoice;
  const details = {
    invoiceId: invoiceId
  };
  const url = getDownloadURL({ module, details, endPoint: 'direct_download' });

  const { rows, grandTotal } = generateInvoiceOrQuoteSummaryRows({
    data,
    editMode,
    intl,
    isXeroIntegrated,
    integrationsLoading,
    integrationsError,
    isSiteWiseSplitEnabled,
    isDetailsPage: true,
    isAdditionalDiscountPercent
  });

  const getPrefix = (el) => {
    switch (el.type) {
      case 'Tag':
        return (
          <div className="flex jend mr10">
            <Tag>{el.prefix}</Tag>
          </div>
        );
      default:
        return <>{el.prefix}</>;
    }
  };
  const getLabel = (el) => {
    switch (el.name) {
      case 'addAdditionalDiscount':
        return (
          <Button
            plain
            onClick={() => {
              modifyData({
                properties: {
                  additionalDiscountRate: '0',
                  additionalDiscountType: DISCOUNT_TYPE.PERCENT
                }
              });
            }}
          >
            <div>{el.label}</div>
          </Button>
        );
      case 'taxEdit':
        return (
          <Dropdown
            className="rule-fields"
            value={
              taxRateList.find(
                (t) => t.taxId === data.taxes?.[0]?.tax?.taxId
              ) || {
                ...data.taxes?.[0]?.tax,
                value: data.taxes?.[0]?.tax?.name,
                label: data.taxes?.[0]?.tax?.name
              }
            }
            onMenuOpen={() => {
              getAllTax();
            }}
            onChange={(val) => {
              modifyData({
                miscProperty: 'clientTax',
                value: { ...omit(val, ['label', 'value']) }
              });
            }}
            classNamePrefix="value_selector"
            formatGroupLabel={formatGroupLabel}
            components={{ IndicatorSeparator, DropdownIndicator }}
            options={taxRateList}
            menuPortalTarget={document.body}
            menuPlacement="auto"
            closeMenuOnScroll={(e) => {
              return (
                e.target &&
                e.target.classList &&
                !(e.target.classList.value.indexOf('menu-list') > -1)
              );
            }}
            name="valueselector"
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (base) => ({ ...base, zIndex: 9999 })
            }}
            noOptionsMessage={() => {
              return taxLoading ? 'Loading...' : 'No options';
            }}
          />
        );
      default:
        return <>{el.label}</>;
    }
  };

  const getValue = (el) => {
    switch (el.name) {
      case 'addAdditionalDiscount':
        return '';
      default:
        return <CurrencyText value={el.value} />;
    }
  };

  const getRate = (el) => {
    switch (el.name) {
      case 'additionalDiscountEdit': {
        const Comp = !isAdditionalDiscountPercent ? CurrencyField : TextField;
        return (
          <div className="ml-10">
            <Comp
              autoComplete="off"
              type="number"
              suffix={
                <div
                  className="flex center pointer h-30 br-5"
                  clicked={clicked}
                  onClick={() => {
                    setClicked(true);
                    modifyData({
                      properties: isAdditionalDiscountPercent
                        ? {
                            additionalDiscount:
                              data.additionalDiscountRate || '0',
                            additionalDiscountRate: null,
                            additionalDiscountType: DISCOUNT_TYPE.AMOUNT
                          }
                        : {
                            additionalDiscount: null,
                            additionalDiscountRate: String(
                              clamp(
                                Number(data.additionalDiscount || '0'),
                                0,
                                100
                              )
                            ),
                            additionalDiscountType: DISCOUNT_TYPE.PERCENT
                          }
                    });
                    setTimeout(() => {
                      setClicked(false);
                    }, 200);
                  }}
                >
                  <div className="flex center">
                    <div>
                      {!isAdditionalDiscountPercent ? 'amount' : 'percent'}
                    </div>
                    <div className="ml4">
                      <SVGIcon name="ArrowDown" />
                    </div>
                  </div>
                </div>
              }
              onChange={(changedVal) => {
                const sTotal = getSubTotal(data?.items);
                const tRates = getTaxes(data);
                const currentTotal = sTotal + tRates;
                let val = changedVal;
                if (
                  !isAdditionalDiscountPercent &&
                  Number(changedVal) > currentTotal
                ) {
                  val = String(currentTotal);
                }
                if (Number(val) < 0) val = '0';
                modifyData({
                  properties: isAdditionalDiscountPercent
                    ? {
                        additionalDiscountRate:
                          Number(val) > 100 ? '100' : val || '',
                        additionalDiscount: null,
                        additionalDiscountType: DISCOUNT_TYPE.PERCENT
                      }
                    : {
                        additionalDiscountRate: null,
                        additionalDiscount: val || '',
                        additionalDiscountType: DISCOUNT_TYPE.AMOUNT
                      }
                });
              }}
              value={
                isAdditionalDiscountPercent
                  ? data.additionalDiscountRate
                  : data.additionalDiscount
              }
            />
          </div>
        );
      }
      case 'additionalDiscount':
        if (isAdditionalDiscountPercent) {
          return `${data.additionalDiscountRate}%`;
        }
        return '';
      default:
        return el.rate ? `${el.rate}%` : '';
    }
  };

  const renderSiteInfo = (info) => {
    if (info) {
      return <div className="site-info">{info}</div>;
    }
    return null;
  };
  const handlePayment = (state) => {
    setPaymentState(state);
  };

  const activator = (
    <Button
      loading={actionLoading}
      onClick={toggleActive}
      icon={<SVGIcon name="Menu" />}
    />
  );

  const voidActivator = (
    <div className="flex center actionListItemPadding ptr">
      <div className="mr-10 flex center">
        <SVGIcon name="Restrict" />
      </div>
      <FormattedMessage id="invoice.payment.markAsVoid" />
    </div>
  );

  const deleteActivator = (
    <div className="flex center actionListItemPadding ptr">
      <div className="mr-10 flex center">
        <SVGIcon name="Delete" color="red" />
      </div>
      <div className="red">
        <FormattedMessage id="invoice.actions.delete" />
      </div>
    </div>
  );

  const notesActivator = (
    <div className="flex center actionListItemPadding ptr">
      <div className="mr-10 flex center">
        <SVGIcon name="Notes" />
      </div>
      {data?.notes ? (
        <FormattedMessage id="invoice.actions.editNote" />
      ) : (
        <FormattedMessage id="invoice.actions.addNote" />
      )}
    </div>
  );

  const editInvoiceActivator = (
    <div
      className="flex center actionListItemPadding ptr"
      onClick={() => {
        setEditMode(true);
        toggleActive();
      }}
    >
      <div className="mr-10 flex center">
        <SVGIcon name="Edit" />
      </div>
      <FormattedMessage id="invoice.details.editInvoice" />
    </div>
  );

  const paymentLinkActivator = (
    <div
      className="flex center actionListItemPadding ptr"
      onClick={() => {
        setGenerateLinkLoading(true);
        generatePaymentLinkToken({
          variables: {
            input: {
              invoiceId: data.invoiceId
            }
          }
        })
          .then((res) => {
            if (res?.data?.generatePaymentLinkToken) {
              setData({
                ...data,
                // paymentLinkToken: res.data.generatePaymentLinkToken
                paymentLink: `https://${companyInfo.customDomain ||
                  companyInfo.portalDomain}/#/payInvoice?token=${
                  res?.data?.generatePaymentLinkToken
                }&invoiceId=${data.invoiceId}&clientId=${
                  data.client?.accountId
                }`
              });
            }
          })
          .finally(() => {
            setGenerateLinkLoading(false);
          });
        toggleActive();
      }}
    >
      <div className="mr-10 flex center">
        <SVGIcon name="LinkDark" />
      </div>
      <FormattedMessage id="invoice.payment.generatePaymentLink" />
    </div>
  );

  const downloadCSV = (
    <div className="unstyledLink">
      <Tippy
        title={getTranslatedText(intl, 'invoice.details.exportCSV')}
        duration={250}
        delay={100}
        placement="bottom-start"
        arrow={false}
        theme="dark"
        appendTo={document.body}
      >
        <UnstyledLink url={url}>
          <div className="flex center  actionListItemPadding  ptr">
            <div className={` mr-10 flex center`}>
              <SVGIcon name="Download" />
            </div>

            <FormattedMessage id="invoice.details.exportCSV" />
          </div>
        </UnstyledLink>
      </Tippy>
    </div>
  );

  const inlineNotesActivator = <SVGIcon name="Edit" />;

  const validateInvoicePaid = (statusObj) => {
    let isInvalid = false;
    const errors = {};
    if (isEmpty(statusObj.paymentReference)) {
      isInvalid = true;
      errors.paymentReference = getTranslatedText(
        intl,
        'dromo.validation.requiredField'
      );
    }
    if (isEmpty(statusObj.paymentMethod.paymentMethodId)) {
      isInvalid = true;
      errors.paymentMethod = getTranslatedText(
        intl,
        'dromo.validation.requiredField'
      );
    }
    if (errors) {
      setInvoicePaidErrors(errors);
    }
    return isInvalid;
  };

  const handleInvoiceUpdate = (statusObj) => {
    setActionLoading(true);
    return updateInvoice({
      variables: {
        updatedInvoice: {
          invoiceId,
          ...statusObj
        },
        isTaxSplitEnabled: true
      },
      input: {
        updatedInvoice: {
          invoiceId,
          ...statusObj
        }
      }
    })
      .then((res) => {
        setActionLoading(false);
        if (res?.data?.updateInvoice) {
          toast('success', 'invoice.status.update.success');
          toggleActive();
          setData({
            ...res?.data?.updateInvoice,
            client: data.client
          });
          setManipulatedData({
            ...res?.data?.updateInvoice,
            client: data.client
          });
        }
      })
      .catch((err) => {
        setActionLoading(false);
      });
  };

  const saveNotes = (value) => {
    if (value.trim() === data.notes) return;
    setActive(false);
    updateInvoice({
      variables: {
        updatedInvoice: {
          invoiceId,
          notes: value.trim() || null
        },
        isTaxSplitEnabled: true
      },
      input: {
        updatedInvoice: {
          invoiceId,
          notes: value.trim() || null
        }
      }
    })
      .then((res) => {
        if (res?.data?.updateInvoice) {
          setData({ ...data, notes: res.data.updateInvoice.notes });
        } else {
          setInvoiceNote(data?.notes);
        }
      })
      .catch(() => {});
  };

  const handleInvoiceDelete = () => {
    deleteInvoice({
      variables: {
        invoiceId
      },
      input: {
        invoiceId
      }
    })
      .then((res) => {
        toggleActive();
        if (res?.data?.deleteInvoice) {
          const invoiceTabId = getTabId({
            module: 'INVOICE',
            data: {
              invoiceId: res.data.deleteInvoice
            }
          });
          ticketContext.closeTab({ id: invoiceTabId });
          toast('success', 'invoice.delete.success');
          EventEmitter.dispatch('refetchClassicViewList');
          invoiceContext.setRecords([]);
        }
      })
      .catch(() => {
        toggleActive();
      });
  };

  const updatePaymentMethod = (field, option) => {
    setPaymentMethod({
      ...option,
      value: option.paymentMethodId,
      label: option.paymentMethodName
    });
  };

  const getMenuActions = () => {
    let menuActions = [];

    if (isInvoiceEditAuthorised) {
      menuActions.push({
        content: editInvoiceActivator,
        onAction: () => {}
      });
    }

    if (isInvoiceEditAuthorised) {
      menuActions = [
        ...menuActions,
        {
          content: (
            <div>
              <ConfirmationModal
                modalActivator={voidActivator}
                description={getTranslatedText(
                  intl,
                  'invoice.payment.confirmation.void.description'
                )}
                handleConfirmation={() => {
                  handleInvoiceUpdate({
                    statusEnum: INVOICE_STATUS.VOID.value
                  });
                }}
                title={getTranslatedText(
                  intl,
                  'invoice.payment.confirmation.title'
                )}
              />
            </div>
          ),
          onAction: () => {}
        },
        {
          content: (
            <div>
              <ConfirmationModal
                modalActivator={notesActivator}
                showCloseButton={false}
                title="Note"
                hideFooterBorder
                template={
                  <Notes>
                    <TextField
                      placeholder={getTranslatedText(
                        intl,
                        'invoice.details.input.notes'
                      )}
                      value={invoiceNote}
                      onChange={(note) => {
                        setInvoiceNote(note);
                      }}
                      maxLength={TEXT_LENGTH.size_5}
                      variant="outline"
                      bgTransparent
                      multiline
                    />
                  </Notes>
                }
                handleConfirmation={() => {
                  saveNotes(invoiceNote);
                }}
                confirmText={getTranslatedText(intl, 'common.confirm')}
              />
            </div>
          ),
          onAction: () => {}
        }
      ];
    }

    if (isStripeIntegrated && !data.paymentLinkToken) {
      menuActions.push({
        content: paymentLinkActivator,
        onAction: () => {}
      });
    }

    menuActions.push({
      content: downloadCSV,
      onAction: () => {}
    });

    if (isInvoiceDeleteAuthorised) {
      menuActions.push({
        content: (
          <div>
            <DeleteModal
              modalActivator={deleteActivator}
              description={getTranslatedText(
                intl,
                'invoice.delete.confirmation.description'
              )}
              handleDeleteConfirmation={handleInvoiceDelete}
              title={getTranslatedText(
                intl,
                'invoice.payment.confirmation.title'
              )}
            />
          </div>
        ),
        onAction: () => {}
      });
    }

    return menuActions;
  };
  const getActions = (col) => {
    switch (col.name) {
      case 'actions':
        return {
          onClick: (meta, integrationType, callback) => {
            pushToThirdParty({
              variables: {
                clientId: meta.client.accountId,
                invoiceId: meta.invoiceId,
                integrationType: integrationType || 'QUICK_BOOKS_ONLINE'
              }
            })
              .then((res) => {
                if (res) {
                  toast(
                    'success',
                    'app.toast.invoice.pushTothirdParty.success'
                  );
                  useActivityTracker({
                    event: 'Client - Sync invoice to QB/Xero'
                  });
                  callback && callback(false);
                  updateSendIntegrationStatus({
                    variables: {
                      invoiceId: meta.invoiceId
                    }
                  });
                }
              })
              .catch((err) => {
                callback && callback(false);
              });
          }
        };
      case 'sendInvoice':
        return {
          onClick: (meta, integrationType, callback) => {
            sendInvoice({
              variables: {
                input: [
                  {
                    invoiceId: meta.invoiceId
                  }
                ]
              }
            })
              .then((res) => {
                if (res) {
                  toast('success', 'app.toast.invoice.sentToclient.success');
                  useActivityTracker({ event: 'Client - Sent invoice' });
                  callback && callback(false);
                  updateSendIntegrationStatus({
                    variables: {
                      invoiceId: meta.invoiceId
                    }
                  });
                }
              })
              .catch((err) => {
                callback && callback(false);
              });
          }
        };
      default:
        return {
          onClick: () => {}
        };
    }
  };

  const LayoutConfiguration = {
    ...defaultLayoutConfigObj,
    ...invoiceSettings?.invoiceTemplate?.layoutConfiguration
  };

  const { mspInfo: mspConf, clientInfo: clientConf } = LayoutConfiguration;

  const showClientConf = Object.keys(clientConf).some((key) => clientConf[key]);

  const isSideConversationAvailable = useCheckFeatureGating(
    'SIDE_CONVERSATIONS'
  )?.enabled;

  const showConversationsTab = () => {
    if (isMsp) {
      if (isSideConversationAvailable) {
        return !props.restrictActions;
        // && isConversationViewAuthorised
      }
      return (
        data?.conversationIds?.length && !props.restrictActions
        // && isConversationViewAuthorised
      );
    }
    return (
      data?.conversationIds?.length &&
      !props.restrictActions &&
      isConversationViewAuthorised
    );
  };

  const sendInvoiceConversation = (data) => {
    const conversationInput = { ...data };
    delete conversationInput.placeholdersUsed;
    delete conversationInput.mentions;

    const inputVariables = {
      conversation: conversationInput,
      invoiceId: invoiceId
    };
    sendInvoiceWithConversation({
      variables: {
        input: inputVariables
      }
    }).then((res) => {
      toast('success', 'app.toast.invoice.sentToclient.success');
      useActivityTracker({ event: 'Client - Sent invoice' });
      setShowSendEmailModal(false);
      console.log(invoiceId, 'ash:: invoiceId');
      updateSendIntegrationStatus({
        variables: {
          invoiceId: invoiceId
        }
      });
    });
  };

  function renderTable(defaultProps) {
    return (
      <TableView
        {...defaultProps}
        columns={columnGroup}
        refreshTable={fetchViewData}
        listInfo={listInfo}
        recordCount={listInfo.totalCount}
        activePage={listInfo.page || 0}
        isLoading={listLoading || data.operationStatus === 'PROGRESS'}
        checkRowHighlight={checkRowHighlight}
        onDragEnd={(newOrderItems) => {
          setData(
            onRowItemDragEnd({
              newOrderItems,
              isSiteWiseSplitEnabled,
              isGroupByCategoryEnabled,
              dataRef
            })
          );
        }}
      />
    );
  }

  const copyPublicPaymentLinkButton = data?.paymentLink &&
    notClient &&
    !includes(
      [INVOICE_STATUS.PAID.value, INVOICE_STATUS.VOID.value],
      data.statusEnum
    ) && (
      <div className="pr-20 fx items-center h-38">
        <div className="flex center">
          <div className="flex center g10">
            <div className="fx g5">
              <SVGIcon name="GlobeSharedView" />
              <TextStyle variation="strong" weight="SemiBold">
                <FormattedMessage id="invoice.payment.paymentLinkGenerated" />:{' '}
              </TextStyle>
            </div>
            <CopyButton
              textToCopy={data?.paymentLink}
              rightAlign={false}
              color="#091EF5"
            />
          </div>
        </div>
      </div>
    );

  const onCloneClick = () => {
    // Payment Term is `Custom` when `paymentTermId` is null
    const isCustomPaymentTerm = data.invoicePaymentTerm?.paymentTermId === null;

    const today = dayjs().format('YYYY-MM-DD');

    const properties = {};

    if (data?.invoicePaymentTerm?.paymentTermId) {
      properties.dueDate = calculateTermAndDueDate(
        today,
        data.invoicePaymentTerm?.placeholder || null,
        data?.invoicePaymentTerm?.paymentTermValue || null
      );
    }

    ticketContext.openTab({
      module: TAB_PAGES.newInvoice,
      data: {
        isClone: true,
        data: {
          ...data,
          statusEnum: INVOICE_STATUS.DRAFT.value,
          paymentTerm: data.invoicePaymentTerm,
          invoiceDate: today,
          dueDate: isCustomPaymentTerm
            ? null
            : properties.dueDate ?? data.dueDate
        }
      },
      url: '/invoice/create'
    });
  };

  function isPaymentInProgress() {
    for (const transaction of data?.transactions || []) {
      const isInProgress = transaction?.mappings?.some(
        (mapping) => mapping?.paymentSyncStatus === 'PROGRESS'
      );
      if (isInProgress) {
        return true;
      }
    }
    return false;
  }

  function renderApplyCreditsButton(text) {
    if (
      !notClient ||
      applyCreditsLoading ||
      Number(data?.amountDue) === 0 ||
      includes(
        [INVOICE_STATUS.PAID.value, INVOICE_STATUS.VOID.value],
        data.statusEnum
      ) ||
      !isInvoiceAddAuthorised
    ) {
      return null;
    }

    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      <span
        onClick={() => {
          useActivityTracker({
            event: 'CREDIT_MANUALLY_APPLIED_TO_INVOICE'
          });
          setApplyCreditsLoading(true);
          updateInvoice({
            variables: {
              updatedInvoice: {
                invoiceId: data?.invoiceId,
                applyCredits: true
              },
              isTaxSplitEnabled: true
            }
          })
            .then((resp) => {
              if (resp?.data?.updateInvoice) {
                setData({ ...data, ...resp.data.updateInvoice });
                setManipulatedData({
                  ...manipulatedData,
                  ...resp.data.updateInvoice
                });

                return refetchCredits();
              }
            })
            .finally(() => {
              setApplyCreditsLoading(false);
            });
        }}
        className="linkText"
      >
        {text}
      </span>
    );
  }

  const invoiceTitleLogic = (
    <div className={`flex center ${typographyClassName}`} style={fontStyles}>
      <div className="pr10">
        {(invoiceTemplateTheme === INVOICE_TEMPLATE_THEME.MODERN ||
          invoiceTemplateTheme === INVOICE_TEMPLATE_THEME.ELEGANT) &&
          mspConf?.companylogo && <BrandingLogo alignVertical hideName />}
      </div>
      {!editMode ? (
        <div
          className="invoice-title font-weight-600 f-20"
          element="h1"
          weight="bold"
        >
          {data.title || `Invoice #${data.displayId}`}
        </div>
      ) : (
        <div className="w30">
          <TextField
            placeholder={getTranslatedText(
              intl,
              'invoice.details.title.placeholder'
            )}
            value={
              data.title !== null ? data.title : `Invoice #${data.displayId}`
            }
            onChange={(val) => {
              updateTitle(val);
            }}
            maxLength={TEXT_LENGTH.size_5}
            bgTransparent
          />
        </div>
      )}
      <div className="ml-10">
        <InvoiceStatusCell
          cell={{
            value: data.statusEnum,
            row: { original: data }
          }}
        />
      </div>
      {data.operationStatus === 'PROGRESS' && (
        <ListInfoBanner message="invoice.details.regeneration.inProgress" />
      )}
    </div>
  );

  function hasTransactionError() {
    for (const transaction of data?.transactions || []) {
      const hasFailed = transaction?.mappings?.some(
        (mapping) => mapping?.paymentSyncStatus === 'FAILURE'
      );
      if (hasFailed) {
        return true;
      }
    }
    return false;
  }

  /*
   * if the invoice is created with `0` as total amount , the statusEnum will be marked as `PAID` from the backend
   *
   */

  const isZeroInvoice =
    includes([INVOICE_STATUS.PAID.value], data.statusEnum) &&
    Number(data.totalAmount) === 0;

  function generateFieldData({
    editmode,
    entity,
    field: fieldData,
    isInactive
  }) {
    // let isEditAuthorised = false;

    const attributes = getEntityAttributes(allEntities, entity);

    const field = attributes?.find((f) => f.name === fieldData?.fieldName);

    if (!field) {
      return null;
    }

    switch (field.name) {
      case 'displayId':
        return (
          <div className="flex center lh-30">
            <span>{getTranslatedText(intl, 'invoice.details.heading')}</span>
            <span className="ml8">
              <B1>{`#${data.displayId}`}</B1>
            </span>
          </div>
        );
      case 'dueDate':
        return (
          <div className="flex center lh-30">
            <FormattedMessage id="invoice.details.dueDate" /> :{' '}
            {editmode ? (
              <DateTimePicker
                selected={data.dueDate && dayjs(data.dueDate).toDate()}
                onChange={(value) =>
                  modifyData({
                    properties: {
                      dueDate: dayjs(value).format('YYYY-MM-DD'),
                      invoicePaymentTerm: {
                        paymentTermName: getTranslatedText(
                          intl,
                          'app.common.custom'
                        ),
                        paymentTermId: null,
                        paymentTermValue: null
                      }
                    }
                  })
                }
                placeholderText={'YYYY-MM-DD'}
                // dateFormat={'yyyy-MM-dd'}
                required
                disabled={false}
                minDate={null}
                popperPlacement="auto"
              />
            ) : (
              <span className="ml8">
                <TextStyle weight="SemiBold">
                  {data.dueDate ? (
                    <DateTimeFormatter
                      type="date"
                      // date={dayjs().format('YYYY-MM-DD')}
                      date={data.dueDate}
                    />
                  ) : (
                    'NA'
                  )}
                </TextStyle>
              </span>
            )}
          </div>
        );
      case 'invoiceDate':
        return (
          <div className="flex center lh-30">
            <FormattedMessage id="invoice.details.invoiceDate" /> :{' '}
            {editmode ? (
              <DateTimePicker
                selected={data.invoiceDate && dayjs(data.invoiceDate).toDate()}
                onChange={(value) => {
                  const propts = {
                    invoiceDate: dayjs(value).format('YYYY-MM-DD')
                  };
                  if (data.invoicePaymentTerm.paymentTermId) {
                    propts.dueDate = calculateTermAndDueDate(
                      value,
                      data?.invoicePaymentTerm?.placeholder || null,
                      data?.invoicePaymentTerm?.paymentTermValue || null
                    );
                  }
                  modifyData({
                    properties: propts
                  });
                }}
                placeholderText={getTranslatedText(
                  intl,
                  'invoice.details.invoiceDate'
                )}
                // dateFormat="yyyy-MM-dd"
                required
                disabled={false}
                minDate={null}
                popperPlacement="auto"
              />
            ) : (
              <span className="ml8">
                <TextStyle weight="SemiBold">
                  {data.invoiceDate ? (
                    <DateTimeFormatter
                      type="date"
                      // date={dayjs().format('YYYY-MM-DD')}
                      date={data.invoiceDate}
                    />
                  ) : (
                    'NA'
                  )}
                </TextStyle>
              </span>
            )}
          </div>
        );
      case 'paymentTerm':
      case 'invoicePaymentTerm':
        return (
          <div className="flex center lh-30">
            <FormattedMessage id="invoice.details.paymentTerm" /> :{' '}
            {editmode ? (
              <TermSelectDropdown
                intl={intl}
                data={data}
                key={data.invoicePaymentTerm?.paymentTermId}
                value={
                  !isEmpty(data.invoicePaymentTerm)
                    ? {
                        ...data.invoicePaymentTerm,
                        label: data.invoicePaymentTerm?.paymentTermName,
                        value: data.invoicePaymentTerm?.paymentTermId
                      }
                    : null
                }
                onChange={handleTermChange}
              />
            ) : (
              <span className="ml8">
                {data?.invoicePaymentTerm?.paymentTermName ? (
                  <B1>{data?.invoicePaymentTerm?.paymentTermName}</B1>
                ) : (
                  'NA'
                )}
              </span>
            )}
          </div>
        );
      default:
        const displayValue =
          entity === 'Client'
            ? data?.client?.customFields?.[field?.name] || ''
            : data?.customFields?.[field?.name] || '';

        // if (isInactive && !displayValue) {
        //   return null;
        // }

        // if (field?.entity === 'Invoice') {
        //   isEditAuthorised = isInvoiceCustomFieldsAuthorised;
        // }

        // if (field?.entity === 'Client') {
        //   isEditAuthorised = isClientCustomFieldsAuthorised;
        // }

        return (
          <div className="flex center lh-30">
            <FormattedMessage id={field?.label || `attribute.${field?.name}`} />
            :{' '}
            {editmode && fieldData?.entity !== 'Client' ? (
              <TextField
                type="text"
                key={`${field?.name}-${fieldData?.entity}-input`}
                value={displayValue}
                onChange={(val) => {
                  modifyData({
                    properties: {
                      customFields: {
                        ...data?.customFields,
                        [field?.name]: val
                      }
                    }
                  });
                }}
                disabled={!!isInactive}
                label={field?.label || `attribute.${field?.name}`}
                labelHidden
              />
            ) : (
              <span className="ml8">
                {displayValue ? (
                  <B1>{displayValue}</B1>
                ) : (
                  <DisabledTag>
                    <FormattedMessage id="app.noData.message" />
                  </DisabledTag>
                )}
              </span>
            )}
          </div>
        );
    }
  }

  function renderEditActionButton() {
    /*
      * Need to hide action button in following cases
      1. If the invoice is paid / voided / partially paid
      2. If the invoice is created with `0` as total amount
      3. Restrict edit when amount due is `0`, handled for ACH stripe payments
      */
    if (!notClient) return null;
    const button = (
      <Popover
        active={active}
        activator={activator}
        preferredAlignment="right"
        onClose={() => {}}
      >
        <div className="pt-5 pb-5 pr10 pl10">
          {getMenuActions()?.map((item) => item.content)}
        </div>
      </Popover>
    );
    if (isZeroInvoice) {
      return button;
    }
    if (
      includes(
        [INVOICE_STATUS.PAID.value, INVOICE_STATUS.VOID.value],
        data.statusEnum
      ) ||
      data.partiallyPaid ||
      Number(data.amountDue) === 0
    ) {
      return null;
    }
    return button;
  }

  function renderMainTableContent() {
    if (isSiteWiseSplitEnabled && !isEmpty(dataGroupedBySite)) {
      return (
        <FlexColumnGap gap={30}>
          {Object.entries(dataGroupedBySite).map(
            ([siteId, { items, siteName }]) => {
              return (
                <InvoiceTableView
                  key={siteId}
                  data={sortItems(items) || []}
                  isSiteWiseSplitEnabled
                  countryCode={countryCode}
                  currencyCode={currencyCode}
                  siteName={siteName}
                  clientName={client.name}
                  renderTable={renderTable}
                />
              );
            }
          )}
        </FlexColumnGap>
      );
    }

    if (isGroupByCategoryEnabled && !isEmpty(dataGroupedByCategory)) {
      return (
        <FlexColumnGap gap={30}>
          {dataGroupedByCategory.map(
            ({ label, items, type, hasTotalHours, totalHours }) => {
              return (
                <InvoiceTableView
                  key={type}
                  hasTotalHours={hasTotalHours}
                  totalHours={totalHours}
                  data={sortItems(items) || []}
                  isGroupByCategoryEnabled
                  countryCode={countryCode}
                  currencyCode={currencyCode}
                  renderTable={renderTable}
                  label={label}
                />
              );
            }
          )}
        </FlexColumnGap>
      );
    }

    return (
      <InvoiceTableView
        data={sortItems(data?.items) || []}
        renderTable={renderTable}
      />
    );
  }

  return (
    <SizeMe monitorHeight monitorWidth>
      {({ size }) => {
        const isLargeScreen = size?.width > 1500;
        const isVeryLargeScreen = size?.width > 2500;
        return (
          <InvoiceThemeWrapper
            className="full-height full-width"
            accentBgColor={
              accentDecider(accent, appContext.darkTheme).accentBgColor
            }
            accentTextColor={
              accentDecider(accent, appContext.darkTheme).accentTextColor
            }
            theme={invoiceTemplateTheme}
            isAccentEnabled={accent.enabled}
          >
            <PageHeader
              className="flex wrap center g5 bg-white"
              restrictActions={props.restrictActions}
            >
              {!props.restrictActions && (
                <Heading>
                  <div className="flex center g10">
                    <Invoice />
                    <div className="flex fcol">
                      <B1 className="invoice-page-heading">
                        <FormattedMessage id="invoice.details.heading" />
                        {/* <FeatureGuide featureName="allinvoice" article video /> */}
                      </B1>
                      {data?.work && isMsp && (
                        <Button
                          plain
                          disabled={
                            data?.work?.module === 'TICKET'
                              ? !isTicketViewAuthorised
                              : data?.work?.module === 'PROJECT'
                              ? !isProjectViewAuthorised
                              : false
                          }
                          onClick={() => {
                            ticketContext.openTab({
                              module:
                                data.work.module === 'PROJECT'
                                  ? 'PROJECT_DETAIL'
                                  : data.work.module,
                              data: {
                                [`${data.work.module.toLowerCase()}Id`]: data
                                  .work.workId
                              }
                            });
                          }}
                        >
                          <div className="flex g10 center mt-5">
                            <FormattedMessage
                              id={`attribute.${data.work.module.toLowerCase()}Id`}
                            />
                            <div>{`#${data?.work?.displayId}`}</div>
                          </div>
                        </Button>
                      )}
                      {data?.quote && (
                        <Button
                          plain
                          disabled={!isQuoteViewAuthorised}
                          onClick={() => {
                            ticketContext.openTab({
                              module: 'QUOTE',
                              data: {
                                quoteId: data.quote.quoteId,
                                displayId: data.quote.displayId
                              }
                            });
                          }}
                        >
                          <div className="flex g10 center mt-5">
                            <FormattedMessage id="quote.name.placeholder" />
                            <div>{`#${data?.quote?.displayId}`}</div>
                          </div>
                        </Button>
                      )}
                    </div>
                  </div>
                </Heading>
              )}
              <div className="mlauto">
                {!props.restrictActions && (
                  <div className="flex">
                    {editMode ? (
                      <ButtonGroup>
                        <Button
                          plainSecondary
                          onClick={() => {
                            setEditMode(false);
                            setData(manipulatedData);
                          }}
                        >
                          <FormattedMessage id="common.cancel" />
                        </Button>
                        <Button
                          onClick={() => {
                            setCustomModal(true);
                          }}
                          icon={<SVGIcon name="ServiceCatalog" />}
                        >
                          <FormattedMessage id="invoice.actions.importFromServiceCatalog" />
                        </Button>
                        <Button
                          icon={<SVGIcon name="RotateRefreshLoading" />}
                          loading={invoiceGenerationInProgress}
                          primary
                          onClick={() => {
                            // setEditMode(false);
                            // setColumnData(false);
                            handleRegeneration();
                          }}
                        >
                          <FormattedMessage id="invoice.details.regenerateInvoice" />
                        </Button>
                      </ButtonGroup>
                    ) : (
                      <ButtonGroup>
                        {notClient &&
                          data.operationStatus !== 'PROGRESS' &&
                          (includes(
                            [
                              INVOICE_STATUS.PAID.value,
                              INVOICE_STATUS.VOID.value
                            ],
                            data.statusEnum
                          ) ||
                            data.partiallyPaid) && (
                            <ExportCSVWrapper>
                              <Button>{downloadCSV}</Button>
                            </ExportCSVWrapper>
                          )}
                        <AccessControl
                          roleToCheck="invoice.add"
                          render={
                            isClassicView ? (
                              <Button
                                onClick={onCloneClick}
                                icon={<SVGIcon name="Clone" />}
                              />
                            ) : (
                              <Button
                                onClick={onCloneClick}
                                icon={<SVGIcon name="Clone" />}
                              >
                                <FormattedMessage id="common.clone" />
                              </Button>
                            )
                          }
                        />
                        <div className="unstyledLink">
                          {/* <UnstyledLink url={downloadDetails}> */}
                          {isClassicView ? (
                            <Tippy
                              title={getTranslatedText(
                                intl,
                                'invoice.details.downloadPDF'
                              )}
                              duration={250}
                              delay={100}
                              placement="bottom-start"
                              arrow={false}
                              theme="dark"
                              appendTo={document.body}
                            >
                              <Button
                                loading={pdfDownloadLoading}
                                onClick={onPdfDownloadClick}
                                icon={<SVGIcon name="Download" />}
                              />
                            </Tippy>
                          ) : (
                            <Button
                              loading={pdfDownloadLoading}
                              onClick={onPdfDownloadClick}
                              icon={<SVGIcon name="Download" />}
                            >
                              <FormattedMessage id="invoice.details.downloadPDF" />
                            </Button>
                          )}
                          {/* </UnstyledLink> */}
                        </div>
                        {data.operationStatus !== 'PROGRESS' &&
                          allowPushToThirdParty &&
                          notClient && (
                            <InvoiceActionButtons
                              cell={{
                                row: { original: { ...data } },
                                column: {
                                  actions: getActions({
                                    name: 'actions'
                                  }),
                                  id: 'pushToThirdParty',
                                  integrationType: thirdPartyAppId
                                },
                                loadingState:
                                  data.pushedToIntegratedAppStatus ===
                                  'PROGRESS'
                              }}
                            />
                          )}
                        {data.operationStatus !== 'PROGRESS' &&
                          notClient &&
                          isEditInvoiceAuthorised && (
                            <Button
                              icon={<SVGIcon name="InvoiceLogo" />}
                              onClick={() => setShowSendEmailModal(true)}
                              loading={sendInvoiceWithConversationLoading}
                            >
                              {data?.sentToClient ? (
                                <FormattedMessage id="invoice.actions.resendInvoice" />
                              ) : (
                                <FormattedMessage id="invoice.actions.sendInvoice" />
                              )}
                            </Button>
                          )}
                        {!includes(
                          HIDE_PAYMENT_BUTTON_FOR_STATUS,
                          data.statusEnum
                        ) &&
                          isStripeIntegrated &&
                          !includes(
                            [
                              INVOICE_STATUS.PAID.value,
                              INVOICE_STATUS.VOID.value
                            ],
                            data.statusEnum
                          ) &&
                          Number(data.amountDue) !== 0 && (
                            <AccessControl
                              roleToCheck="paymentSettings.view"
                              render={
                                <Button
                                  onClick={setPaymentState.bind(this, 'cards')}
                                  primary
                                  icon={
                                    <SVGIcon name="Billable" color="#fff" />
                                  }
                                  // loading={submitActionLoading}
                                >
                                  <FormattedMessage id="admin.integrations.stripe.payment.button" />
                                </Button>
                              }
                            />
                          )}
                        {!includes(
                          HIDE_PAYMENT_BUTTON_FOR_STATUS,
                          data.statusEnum
                        ) &&
                          data.operationStatus !== 'PROGRESS' &&
                          currentPaymentIntegration &&
                          !includes(
                            [
                              INVOICE_STATUS.PAID.value,
                              INVOICE_STATUS.VOID.value
                            ],
                            data.statusEnum
                          ) &&
                          data?.paymentLink && (
                            <Button
                              onClick={() => {
                                window.open(data?.paymentLink, '_blank');
                              }}
                              primary
                              icon={<SVGIcon name="Billable" color="#fff" />}
                              // loading={submitActionLoading}
                            >
                              <FormattedMessage
                                id="admin.integrations.alternativePayments.payment.button"
                                values={{
                                  alternativePaymentsId:
                                    integrationKeyMap[
                                      currentPaymentIntegration?.integrationId
                                    ]
                                }}
                              />
                            </Button>
                          )}

                        {notClient &&
                          !includes(
                            [
                              INVOICE_STATUS.PAID.value,
                              INVOICE_STATUS.VOID.value
                            ],
                            data.statusEnum
                          ) &&
                          Number(data.amountDue) !== 0 && (
                            <RecordPaymentModal
                              invoiceTotal={data?.totalAmount}
                              hasCredits={hasClientCredits}
                              clientId={data?.client?.accountId}
                              invoiceId={data?.invoiceId}
                              invoiceData={data}
                            />
                          )}

                        {renderEditActionButton()}
                      </ButtonGroup>
                    )}
                  </div>
                )}
              </div>
            </PageHeader>
            <FixedPositionActionsGroup
              position={{
                top: 200
              }}
              actions={[
                {
                  name: 'quote.details.conversations',
                  icon: 'Conversation',
                  onClick: () => toggleSheetActive('Conversation'),
                  visible: showConversationsTab() && !isLargeScreen
                },
                {
                  name: 'client.new.additional.label',
                  icon: 'CollapseRight',
                  onClick: () => toggleSheetActive('AdditionalProperties'),
                  visible:
                    isInvoiceCustomFieldsAuthorised &&
                    !props.restrictActions &&
                    !isVeryLargeScreen
                }
              ].filter((action) => action.visible)}
            />
            <ContentWrap
              className={`${
                isOpenedViaNonLogin ? 'flex' : ''
              } center jcenter g20 fh`}
              bgcolor="var(--sops-lightpurple-to-black-bg)"
              restrictActions={props.restrictActions}
            >
              <Wrapper
                isClassicView={isClassicView}
                fullHeight
                contentPadding="20px 0"
                className={`full-height fw ${
                  isClassicView ? `border-top ` : 'p20'
                } ${
                  isLargeScreen
                    ? 'flex center jcenter full-width large-screen'
                    : ''
                } ${isOpenedViaNonLogin ? 'scroll' : ''}`}
                clicked={clicked}
                ref={(node) => {
                  if (!invoiceNode.current) {
                    invoiceNode.current = node;
                  }
                }}
                isChatVisible={
                  isLargeScreen &&
                  data?.conversationIds?.length &&
                  isConversationViewAuthorised
                }
              >
                <div
                  className={`full-height white-grey-page g20 ${
                    isLargeScreen ? 'flex center mw-100 pt10' : ''
                  }`}
                >
                  {paymentState === 'list' ? (
                    <Page
                      variant="primary"
                      contentHeight={isOpenedViaNonLogin ? '115px' : '135px'}
                      title={invoiceTitleLogic}
                      primaryAction={
                        <div className="fx items-center fhp">
                          <Stamp
                            statusEnum={data.statusEnum}
                            partiallyPaid={data.partiallyPaid}
                          />

                          {!props.restrictActions && (
                            <InvoiceUsageReportPreviewButton
                              invoiceId={data.invoiceId}
                              onDataChange={(hasUsage) => {
                                hasUsagereportRef.current = hasUsage;
                              }}
                            />
                          )}
                          {copyPublicPaymentLinkButton}
                          {!props.restrictActions &&
                            data?.transactions?.length > 0 && (
                              <PaymentSummaryButton
                                displayId={data?.displayId || ''}
                                invoiceId={data?.invoiceId || ''}
                              />
                            )}
                          {props.restrictActions && (
                            <ButtonGroup>
                              {!includes(
                                HIDE_PAYMENT_BUTTON_FOR_STATUS,
                                data.statusEnum
                              ) &&
                                data.operationStatus !== 'PROGRESS' &&
                                isStripeIntegrated &&
                                !includes(
                                  [
                                    INVOICE_STATUS.PAID.value,
                                    INVOICE_STATUS.VOID.value
                                  ],
                                  data.statusEnum
                                ) && (
                                  <Button
                                    onClick={() => {
                                      window
                                        .open(
                                          `#/invoiceList/${invoiceId}/detail`
                                        )
                                        .focus();
                                    }}
                                    primary
                                    icon={
                                      <SVGIcon name="Billable" color="#fff" />
                                    }
                                    // loading={submitActionLoading}
                                  >
                                    <FormattedMessage id="admin.integrations.stripe.payment.button" />
                                  </Button>
                                )}
                              <div className="unstyledLink">
                                <Button
                                  loading={
                                    pdfDownloadLoading ||
                                    props?.isPdfDownloading
                                  }
                                  onClick={() => {
                                    props.redirectUrl();
                                  }}
                                  icon={<SVGIcon name="Download" />}
                                >
                                  <FormattedMessage id="invoice.details.downloadPDF" />
                                </Button>
                              </div>
                              <Button
                                onClick={() => {
                                  window
                                    .open(`#/invoiceList/${invoiceId}/detail`)
                                    .focus();
                                }}
                                icon={<SVGIcon name="RoleAndPermission" />}
                              >
                                <FormattedMessage id="invoice.details.gotoPortal" />
                              </Button>
                            </ButtonGroup>
                          )}
                        </div>
                      }
                    >
                      {/* Banner section starts here */}
                      {!includes(
                        [INVOICE_STATUS.PAID.value, INVOICE_STATUS.VOID.value],
                        data.statusEnum
                      ) &&
                        !props.restrictActions &&
                        hasClientCredits &&
                        !invoiceSettings?.autoApplyCredits && (
                          <div className="pb20 pl20 pr-20">
                            <Banner hideIcon status="info">
                              <RowLayout gap={10}>
                                <SVGIcon name="Wallet" />
                                <TextStyle variation="strong" weight="medium">
                                  <FormattedMessage
                                    id="invoice.partialPayments.availableCreditBanner"
                                    values={{
                                      amount: (
                                        <CurrencyText
                                          value={availableCredits}
                                        />
                                      ),
                                      applyCredits: renderApplyCreditsButton
                                    }}
                                  />
                                </TextStyle>
                                {applyCreditsLoading && (
                                  <div className="pt-10 pl-10 w-fit">
                                    <Loader />
                                  </div>
                                )}
                              </RowLayout>
                            </Banner>
                          </div>
                        )}

                      {hasTransactionError() && !props.restrictActions && (
                        <div className="pb20 pl20 pr-20">
                          <Banner status="critical">
                            <RowLayout gap={10}>
                              <FormattedMessage id="invoice.partialPayments.errorGeneric" />
                              <PaymentSummaryButton
                                displayId={data?.displayId || ''}
                                invoiceId={data?.invoiceId || ''}
                                isPlain
                              />
                            </RowLayout>
                          </Banner>
                        </div>
                      )}

                      {!isOpenedViaNonLogin &&
                        notClient &&
                        allowPushToThirdParty &&
                        (data?.pushedToIntegratedAppError?.length > 0 ||
                          data?.pushPaymentToIntegratedAppError?.length >
                            0) && (
                          <div className="content-padding mb40">
                            <InvoiceErrors
                              integratedAppId={thirdPartyAppId}
                              paymentErrors={
                                data.pushPaymentToIntegratedAppError || []
                              }
                              thirdPartyErrors={
                                data.pushedToIntegratedAppError || []
                              }
                            />
                          </div>
                        )}

                      {generateLinkLoading && (
                        <div className="content-padding mb20">
                          <Banner status="info" hideIcon>
                            <div className="flex center">
                              <div className="flex center g10">
                                <FormattedMessage id="invoice.payment.generatingPaymentLink" />
                              </div>
                            </div>
                          </Banner>
                        </div>
                      )}

                      {data?.notes && notClient && (
                        <div className="content-padding mb40">
                          <Banner status="info" hideIcon>
                            <div className="flex center">
                              <div className="ws-prewrap">{data.notes}</div>
                              <div className="mlauto pointer">
                                <ConfirmationModal
                                  modalActivator={inlineNotesActivator}
                                  title="Note"
                                  template={
                                    <Notes>
                                      <TextField
                                        placeholder={getTranslatedText(
                                          intl,
                                          'invoice.details.input.notes'
                                        )}
                                        value={invoiceNote}
                                        onChange={(note) => {
                                          setInvoiceNote(note);
                                        }}
                                        maxLength={TEXT_LENGTH.size_5}
                                        variant="outline"
                                        bgTransparent
                                        multiline
                                      />
                                    </Notes>
                                  }
                                  handleConfirmation={() => {
                                    saveNotes(invoiceNote);
                                  }}
                                  confirmText={getTranslatedText(
                                    intl,
                                    'common.save'
                                  )}
                                />
                              </div>
                            </div>
                          </Banner>
                        </div>
                      )}

                      {/* Banner Section ends here */}

                      <div className={typographyClassName} style={fontStyles}>
                        <ClientInfo className="grid g40 content-padding">
                          <div className="flex">
                            <div>
                              {invoiceTemplateTheme ===
                                INVOICE_TEMPLATE_THEME.CLASSIC &&
                                mspConf?.companylogo && (
                                  <BrandingLogo alignVertical hideName />
                                )}

                              {invoiceTemplateTheme ===
                                INVOICE_TEMPLATE_THEME.CLASSIC && (
                                <SanitizedAddress
                                  address={manipulatedData?.senderAddress}
                                  header={
                                    <div className="capitalize">
                                      <DisplayText
                                        element="h6"
                                        size="large"
                                        weight="SemiBold"
                                      >
                                        <FormattedMessage id="common.from" />
                                      </DisplayText>
                                    </div>
                                  }
                                />
                              )}
                            </div>
                            <div
                              className={`${
                                invoiceTemplateTheme ===
                                INVOICE_TEMPLATE_THEME.CLASSIC
                                  ? 'mlauto flex center self-start'
                                  : 'fw'
                              }`}
                            >
                              <div
                                className={`${invoiceTemplateTheme ===
                                  INVOICE_TEMPLATE_THEME.CLASSIC &&
                                  'flex col aend self-start g10'} `}
                              >
                                <ActiveIntegrationId
                                  integrationAppAndInvoiceId={
                                    integrationAppAndInvoiceId
                                  }
                                />
                                <div className="custom-fields-wrapper">
                                  <RowLayout
                                    className={`${
                                      invoiceTemplateTheme ===
                                      INVOICE_TEMPLATE_THEME.ELEGANT
                                        ? 'p20'
                                        : ''
                                    } space-between`}
                                  >
                                    <DateSection
                                      className={`${invoiceTemplateTheme ===
                                        INVOICE_TEMPLATE_THEME.CLASSIC &&
                                        'flex col aend self-start g10'} ${invoiceTemplateTheme ===
                                        INVOICE_TEMPLATE_THEME.MODERN &&
                                        'custom-fields--modern'} ${invoiceTemplateTheme ===
                                        INVOICE_TEMPLATE_THEME.ELEGANT &&
                                        'custom-fields--elegant'}`}
                                    >
                                      <InvoiceCustomFields
                                        fieldSettings={
                                          invoiceSettings?.invoiceTemplate
                                            ?.preferences?.fieldSettings
                                        }
                                        inactiveFields={inactiveFields}
                                        editMode={editMode}
                                        loading={entitiesLoading}
                                        generateFieldData={generateFieldData}
                                      />
                                    </DateSection>
                                    {invoiceTemplateTheme ===
                                      INVOICE_TEMPLATE_THEME.ELEGANT && (
                                      <SanitizedAddress
                                        alignRight
                                        address={manipulatedData?.senderAddress}
                                        header={
                                          <div className="capitalize">
                                            <DisplayText
                                              element="h6"
                                              size="large"
                                              weight="SemiBold"
                                            >
                                              <FormattedMessage id="common.from" />
                                            </DisplayText>
                                          </div>
                                        }
                                      />
                                    )}
                                  </RowLayout>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            className={`${
                              invoiceTemplateTheme ===
                              INVOICE_TEMPLATE_THEME.MODERN
                                ? 'custom-fields--modern'
                                : 'fx g120'
                            }`}
                          >
                            {invoiceTemplateTheme ===
                              INVOICE_TEMPLATE_THEME.MODERN && (
                              <SanitizedAddress
                                address={manipulatedData?.senderAddress}
                                header={
                                  <div className="capitalize">
                                    <DisplayText
                                      element="h6"
                                      size="large"
                                      weight="SemiBold"
                                    >
                                      <FormattedMessage id="common.from" />
                                    </DisplayText>
                                  </div>
                                }
                              />
                            )}
                            {showClientConf && (
                              <SanitizedAddress
                                address={manipulatedData?.billingAddress}
                                header={
                                  <div>
                                    <DisplayText
                                      element="h6"
                                      size="large"
                                      weight="SemiBold"
                                    >
                                      <FormattedMessage id="invoice.details.billTo" />
                                    </DisplayText>
                                  </div>
                                }
                              />
                            )}

                            {invoiceSettings?.invoiceTemplate?.preferences
                              ?.shipToEnabled && showClientConf ? (
                              <SanitizedAddress
                                address={manipulatedData?.shippingAddress}
                                header={
                                  <div>
                                    <DisplayText
                                      element="h6"
                                      size="large"
                                      weight="SemiBold"
                                    >
                                      <FormattedMessage id="invoice.details.shipTo" />
                                    </DisplayText>
                                  </div>
                                }
                              />
                            ) : (
                              <div />
                            )}
                          </div>
                        </ClientInfo>

                        {/* Table */}
                        <div className="mt40 content-padding">
                          <TableContainer>
                            <ContentDeciderContainer
                              isLoading={!columnGroup[0]?.columns?.length}
                              hasContent
                              fullHeight
                              mainContent={renderMainTableContent()}
                              loadingContent={<TableLoading rows={15} />}
                              notFoundURL={`${envConfig.imageRoot}svg/not-found.svg`}
                            />
                          </TableContainer>
                        </div>

                        <div className="total-section mt-30 content-padding pb-100 pr-25 flex g20">
                          {data?.memo && !editMode && (
                            <div className="flex fg1">
                              <DisplayMemo className="mt10">
                                <TextField
                                  value={data?.memo}
                                  multiline
                                  disabled
                                  autoComplete="off"
                                />
                              </DisplayMemo>
                            </div>
                          )}
                          {editMode && (
                            <MemoGetter className="mt10 flex fg1">
                              <TextField
                                placeholder={getTranslatedText(
                                  intl,
                                  'admin.invoiceTemplate.customisation.invoiceMessage.placeholder'
                                )}
                                value={data?.memo}
                                onChange={(val) => {
                                  updateMemo(val);
                                }}
                                multiline
                                maxLength={TEXT_LENGTH.size_5}
                                autoComplete="off"
                              />
                            </MemoGetter>
                          )}
                          <div className="mt10 mlauto mr8">
                            <div className="mt10 mlauto mr8 w700">
                              {rows.length > 0
                                ? rows.map((el, idx) => {
                                    return (
                                      <Row
                                        className={`flex center mlauto ${
                                          idx === 0 ? 'dash-separator' : ''
                                        }`}
                                      >
                                        <div className="grow-1 fb-25 self-start mr10">
                                          {getPrefix(el)}
                                        </div>
                                        <div className="grow-1 fb-25 self-start mr10">
                                          {getLabel(el)}
                                        </div>
                                        <div className="grow-1 fb-25 self-start mr10">
                                          {getRate(el)}
                                        </div>
                                        <div className="flex jend pr-20 bold grow-1 fb-25 self-start mr10">
                                          {getValue(el)}
                                        </div>
                                      </Row>
                                    );
                                  })
                                : ''}
                            </div>
                            <div className="flex mr8 mt-30 min-width-400">
                              <div className="mlauto bold f-20 w50">
                                <Card
                                  variant="secondaryCard"
                                  border="secondary"
                                >
                                  {/* TOTAL */}
                                  <div className="total-card-wrapper">
                                    <div
                                      className={`total-card ${data.partiallyPaid &&
                                        'border-bottom-grey'}`}
                                    >
                                      <RowLayout
                                        gap={10}
                                        className="pt20 pr-20 pb20 pl20 fx-sb"
                                      >
                                        <div className="fb-50 fb50 jend">
                                          <FormattedMessage id="invoice.details.total" />
                                        </div>
                                        <div className="flex jend mlauto">
                                          <CurrencyText value={grandTotal} />
                                        </div>
                                      </RowLayout>
                                    </div>
                                    {data.partiallyPaid && (
                                      <Column
                                        gap={15}
                                        className="pt20 pr-20 pb20 pl20 total-card-partiallyPaid-section"
                                      >
                                        {/* Amount Paid */}
                                        <RowLayout className="space-between">
                                          <DisplayText
                                            element="div"
                                            size="large"
                                            weight="Regular"
                                          >
                                            <FormattedMessage id="invoice.partialPayments.amountPaid" />
                                          </DisplayText>
                                          <DisplayText
                                            element="div"
                                            size="extraLarge"
                                            weight="Medium"
                                          >
                                            <CurrencyText
                                              value={data?.amountPaid}
                                            />
                                          </DisplayText>
                                        </RowLayout>
                                        {/* Balance Due */}
                                        <RowLayout className="space-between">
                                          <RowLayout gap={10}>
                                            <SVGIcon name="Warning" />
                                            <DisplayText
                                              element="div"
                                              size="large"
                                              weight="Regular"
                                            >
                                              <FormattedMessage id="invoice.partialPayments.balanceDue" />
                                            </DisplayText>
                                          </RowLayout>
                                          <DisplayText
                                            element="div"
                                            size="extraLarge"
                                            weight="Medium"
                                          >
                                            <CurrencyText
                                              value={data?.amountDue}
                                            />
                                          </DisplayText>
                                        </RowLayout>
                                      </Column>
                                    )}
                                  </div>
                                </Card>
                              </div>
                            </div>
                          </div>
                        </div>
                        {data?.footer && !editMode ? (
                          <div className="mt-20 p20 border-top-gray">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: dompurifier(data?.footer)
                              }}
                            />
                          </div>
                        ) : (
                          ''
                        )}
                        {editMode && (
                          <div>
                            <EditorHolder>
                              <EmailEditor
                                template={data?.template}
                                updateTemplate={updateTemplate}
                                placeholder={getTranslatedText(
                                  intl,
                                  'admin.invoiceTemplate.customisation.footer.placeholder'
                                )}
                                module="INVOICE_TEMPLATE"
                                details={{
                                  operation: 'CREATE'
                                }}
                                isUploading={false}
                              />
                            </EditorHolder>
                          </div>
                        )}
                      </div>
                    </Page>
                  ) : (
                    <InvoicePayment
                      handlePayment={handlePayment}
                      client={client}
                      data={data}
                    />
                  )}

                  {showConversationsTab() && (
                    // InvoiceDetails__ChatWrapper
                    <ChatWrapper
                      isClassicView={isClassicView}
                      className="border-left-gray"
                    >
                      <ChatHolder
                        invoiceNode={invoiceNode}
                        data={data}
                        invoiceId={invoiceId}
                        toggleSheetActive={toggleSheetActive}
                        sheetActive={
                          sheetActive && activeSheetName === 'Conversation'
                        }
                        isLargeScreen={isLargeScreen}
                      />
                    </ChatWrapper>
                  )}

                  {isMsp && isInvoiceCustomFieldsAuthorised && (
                    <AdditionalPropertiesHolder
                      mode={editMode ? 'edit' : 'view'}
                      filterFields={invoiceSettings?.invoiceTemplate?.preferences?.fieldSettings?.map(
                        (field) => field?.fieldName
                      )}
                      customFieldsData={data?.customFields}
                      onChangeHandler={(properties) => {
                        console.log(properties, ' => properties');
                        const clonedData = cloneDeep(data);
                        const updatedata = {
                          ...clonedData,
                          customFields: {
                            ...clonedData?.customFields,
                            ...properties
                          }
                        };
                        setData(updatedata);
                      }}
                      toggleSheetActive={toggleSheetActive}
                      sheetActive={
                        sheetActive &&
                        activeSheetName === 'AdditionalProperties'
                      }
                      isLargeScreen={isVeryLargeScreen}
                    />
                  )}
                  {customModal && (
                    <CustomModal open={customModal} onClose={closeModal}>
                      <ItemsToInvoice
                        client={client}
                        site={billTo}
                        updateProperties={updateProperties}
                        closeModal={closeModal}
                        invoiceData={data}
                        generateSiteSpecific={
                          invoiceSettings?.enableSiteSpecificInvoice
                        }
                        taxExempted={!invoiceSettings?.taxable}
                      />
                    </CustomModal>
                  )}
                  {showSendEmailModal && (
                    <CustomModal
                      open={showSendEmailModal}
                      onClose={() => setShowSendEmailModal(false)}
                      zIndex={500}
                    >
                      <SendEmailModal
                        hasUsageReport={
                          hasUsagereportRef.current &&
                          invoiceSettings?.attachUsagePdf
                        }
                        primaryAction={sendInvoiceConversation}
                        resetState={() => setShowSendEmailModal(false)}
                        invoiceId={invoiceId}
                        displayId={data?.displayId}
                        accountId={data.client.accountId}
                        primaryActionLoading={
                          sendInvoiceWithConversationLoading
                        }
                        attachPdf={invoiceSettings?.attachPdf}
                      />
                    </CustomModal>
                  )}
                </div>
              </Wrapper>
            </ContentWrap>
          </InvoiceThemeWrapper>
        );
      }}
    </SizeMe>
  );
}

// function AdditionalPropertiesHolder(props) {
//   const {
//     data,
//     sheetActive,
//     toggleSheetActive,
//     isLargeScreen,
//     invoiceId
//   } = props;
//   if (!isLargeScreen) {
//     return (
//       <Sheet size="large" open={sheetActive} onClose={toggleSheetActive}>
//         <div className="fh scroll bg-white">
//           <InvoiceAdditionalProperties
//           // invoiceId={invoiceId}
//           // conversationIds={data?.conversationIds}
//           // clientId={data?.client?.accountId}
//           // conversationInfo={data?.conversationInfo}
//           />
//         </div>
//       </Sheet>
//     );
//   }
//   return (
//     <InvoiceAdditionalProperties
//       outsideSheet
//       // invoiceId={invoiceId}
//       // clientId={data?.client?.accountId}
//       // conversationIds={data?.conversationIds}
//       // conversationInfo={data?.conversationInfo}
//     />
//   );
// }

function ChatHolder(props) {
  const {
    data,
    sheetActive,
    toggleSheetActive,
    isLargeScreen,
    invoiceId
  } = props;
  if (!isLargeScreen) {
    return (
      <Sheet size="large" open={sheetActive} onClose={toggleSheetActive}>
        <div className="fh scroll bg-white">
          <InvoiceConversations
            invoiceId={invoiceId}
            conversationIds={data?.conversationIds}
            clientId={data?.client?.accountId}
            conversationInfo={data?.conversationInfo}
          />
        </div>
      </Sheet>
    );
  }
  return (
    <ChatWrapper>
      <InvoiceConversations
        outsideSheet
        invoiceId={invoiceId}
        clientId={data?.client?.accountId}
        conversationIds={data?.conversationIds}
        conversationInfo={data?.conversationInfo}
      />
    </ChatWrapper>
  );
}

function CopyButton({ textToCopy, rightAlign = true, onCopy, color = '#000' }) {
  const [isCopied, copyToClipboard] = useCopyToClipboard();

  return (
    <CopyButtonContainer rightAlign={rightAlign} color={color}>
      <div
        className="flex center g5 pointer"
        onClick={() => {
          if (onCopy) onCopy();
          copyToClipboard(textToCopy);
        }}
      >
        {isCopied ? (
          <LoadingSuccess />
        ) : (
          <SVGIcon name="CopyClipboard" size="md" color={color} />
        )}
        <FormattedMessage
          id={`onboarding.migrate.modal.${isCopied ? 'copied' : 'copy'}`}
        />
      </div>
    </CopyButtonContainer>
  );
}

export default injectIntl(withRouter(withLDConsumer()(InvoiceDetails)));
